var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"info"},[_vm._v("Copyright 2018 . All Rights Reserved. 天津智尧网络通信技术有限公司 津ICP备19010183号 ")])])
}]

export { render, staticRenderFns }